// extracted by mini-css-extract-plugin
export default {"reportBody":"ReportTableBody_reportBody__Vgxlw","reportBodyItem":"ReportTableBody_reportBodyItem__UvNqB"};